import request from "@/utils/request";
// 课程管理
export function getList(where) {
    return request.get("/business/course", where, {
        login: true,
    });
}

export function getBanner(where) {
    return request.get("/business/course/queryConfig", where);
}

// 课件管理
export function getListDetail(where) {
    return request.get("/business/course/detail", where);
}

export function getInfoDetail(where) {
    return request.get("/business/course/detail/info", where);
}

// 专栏验证码校验
export function validateColumnCode(where) {
    return request.get("/business/course/list/before", where);
}

// 文章积分消耗
export function coursePayScore(where) {
    return request.get("/business/course/detail/before", where);
}